// PWA auto-update: чистая логика решений (пара к AppUpdateNotifier.vue и
// registerServiceWorker.js), вынесена по образцу staleChunk.js для unit-покрытия.
//
// Ключевой инвариант (ревью PR #78, Critical): SKIP_WAITING активирует новый SW
// для ВСЕГО origin, и controllerchange прилетает во ВСЕ вкладки. Перезагружаться
// по нему может только вкладка, которая скрыта или сама запросила обновление —
// видимая вкладка с несохранённой формой должна получить снекбар, а не reload.

// Новый SW установлен и ждёт. hidden → активируем тихо, иначе показываем снекбар.
export function onUpdateAvailableAction({ hidden }) {
  return hidden ? "apply" : "snackbar";
}

// Новый SW взял контроль (controllerchange — во всех вкладках origin!).
//   reload   — вкладка скрыта или сама инициировала апдейт;
//   snackbar — видимая вкладка, не просившая обновления: живёт на старых ассетах
//              до клика (или ухода в фон), форма не теряется;
//   none     — уже перезагружаемся.
export function onControllerChangeAction({ reloading, hidden, updateRequested }) {
  if (reloading) return "none";
  if (hidden || updateRequested) return "reload";
  return "snackbar";
}

// Вкладка ушла в фон. controllerChanged → можно перезагрузить (юзер вернётся в
// свежую версию); есть waiting и мы ещё не просили → активируем.
export function onHiddenAction({ reloading, controllerChanged, waitingWorker, updateRequested }) {
  if (reloading) return "none";
  if (controllerChanged) return "reload";
  if (waitingWorker && !updateRequested) return "apply";
  return "none";
}

// Throttle проверок нового SW по возврату фокуса (registerServiceWorker.js).
export function shouldCheckOnVisible({ hidden, now, lastCheck, minGapMs }) {
  return !hidden && now - lastCheck > minGapMs;
}

// Кому слать SKIP_WAITING. Захваченный в момент updated() воркер мог протухнуть:
// пока снекбар висел, приехал ещё более новый деплой — старый waiting стал
// redundant (postMessage уходит в пустоту, юзер жмёт кнопку без эффекта).
// Свежий registration.waiting всегда приоритетнее; захваченный — только если жив.
export function resolveWorkerToSignal({ freshWaiting, capturedWaiting }) {
  if (freshWaiting) return freshWaiting;
  if (capturedWaiting && capturedWaiting.state !== "redundant") return capturedWaiting;
  return null;
}

// Страховочный reload после запрошенной активации: controllerchange может не
// прийти (воркер протух; страница ещё не под контролем SW — первый визит после
// установки самого первого SW). Явный запрос юзера не должен «молчать».
export const FALLBACK_RELOAD_MS = 4000;
